import { VendorRegion } from "../services";
import { Locale, RegionLocaleObject } from "../types";

export const REGIONS_WITH_LOCALES: {
  [key in VendorRegion]: RegionLocaleObject[];
} = {
  BAU: [{ locale: "en_AU", name: "English", isDefault: true, isEnglish: true, emoji: "🇦🇺" }],
  BUK: [{ locale: "en_GB", name: "English", isDefault: true, isEnglish: true, emoji: "🇬🇧" }],
  BUS: [{ locale: "en_US", name: "English", isDefault: true, isEnglish: true, emoji: "🇺🇸" }],
  BDE: [
    { locale: "de_DE", name: "German", isDefault: true, isEnglish: false, emoji: "🇩🇪" },
    { locale: "en_DE", name: "English", isDefault: false, isEnglish: true, emoji: "🇬🇧" },
  ],
};

export const REGIONS_TO_COUNTRY_DEFAULT_LOCALE: { [key in VendorRegion]: string } = {
  BAU: "en_AU",
  BUS: "en_US",
  BUK: "en_GB",
  BDE: "de_DE",
};

export const DEFAULT_USER_LOCALE: Locale = "en_US";

export const VENDOR_KEY_REGEX: string = "^b[a-z]{2}:ven\\d+$";
